import { useState } from "react";
import { JumboDdPopover } from 'themes/jumbo/@jumbo/components/JumboDdPopover';
import { useJumboTheme } from 'themes/jumbo/@jumbo/components/JumboTheme/hooks';
import { Div } from 'themes/jumbo/@jumbo/shared';
import LogoutIcon from '@mui/icons-material/Logout';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import CodeOutlinedIcon from '@mui/icons-material/CodeOutlined';
import { useAccount, useMsal } from "@azure/msal-react";
import { useHistory } from 'react-router-dom';
import RequestQuoteOutlinedIcon from '@mui/icons-material/RequestQuoteOutlined';
import { useDispatch, useSelector} from 'react-redux';
import { RootState } from 'store';
import EventsEmitter from "events/EventsEmitter";
import { openDialog } from "store/main/newsLetterDialog";


import {
  Avatar,
  Divider,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  ThemeProvider,
  Typography,
  Tooltip
} from '@mui/material';

import { trackEvent } from "components/Tracking";


const AuthUserPopover = () => {
	const history = useHistory();
	const { theme } = useJumboTheme();
	const { accounts, instance } = useMsal();
	const account = useAccount(accounts[0] || {});
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const dispatch = useDispatch();

  const planStore = useSelector((state:RootState) => state.auth.data)

	// const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
	// 	setAnchorEl(event.currentTarget);
	// };

  
	const handleAccount = (path:any, target:boolean) => {
    EventsEmitter.emit("closeProfilePanel", "");
    if(target)
      window.open(path, '_blank');
    else
		  history.push(path);
	}
  
	const logout = (logoutType: string) => {
    trackEvent("User", "Logout", "");
		setAnchorEl(null);
		if (logoutType === "popup") {
			instance.logoutPopup({
				mainWindowRedirectUri: "/",
			});
		} else if (logoutType === "redirect") {
			instance.logoutRedirect();
		}
	};

	const stringAvatar = (name: any) => {
   
		if(name) {
			let cname = name && name.toUpperCase()
			let user = cname;

			const fullName = cname.split(' ');
					
			if(fullName.length > 1)

				return {
					
					sx: {
					bgcolor: '#3dabe6',
					},
					children: `${user.split(' ')[0][0]}${user.split(' ')[1][0]}`,
				};
			else
				return {
						
					sx: {
					bgcolor: '#3dabe6',
					},
					children: `${user.split(' ')[0][0]}`,
				};
		}
		else
			return null
		}

  	return (
    <ThemeProvider theme={theme}>
      <JumboDdPopover
        hidePopup={false}
        triggerButton={
          <Tooltip title="User Profile" placement="top" arrow>
            <Avatar {...stringAvatar(account?.name)} style={{ fontSize: '16px', cursor: 'pointer' }}/>
          </Tooltip>
          // <Avatar
          //   src={authUser?.profile_pic}
          //   sizes={'small'}
          //   sx={{ boxShadow: 23, cursor: 'pointer' }}
          // />
        }
        sx={{ ml: 3 }}
      >
        <Div
          sx={{
            minWidth: 250,
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
            p: (theme) => theme.spacing(2.5),
          }}
        >
        <Avatar {...stringAvatar(account?.name)} />
              {/* <Avatar
                src={authUser?.profile_pic}
                sizes={'small'}
                sx={{ boxShadow: 23, cursor: 'pointer' }}
              /> */}
              <Typography>{account?.name}</Typography>
              <Typography variant={'body1'} color='text.secondary'>
                {account?.username}
              </Typography>
            </Div>
          <Divider />
          <nav>
            <List disablePadding sx={{ pb: 1 }}>
              {
              planStore.ipn_name !== 'free' ?
              <ListItemButton onClick={() => {
				 	trackEvent("UserProfile", "Menu", "Billing");
					handleAccount('https://secure.2co.com/myaccount/', true);
			  }}>
                <ListItemIcon sx={{ minWidth: 36 }}>
                  <RequestQuoteOutlinedIcon />
                </ListItemIcon>
                <ListItemText primary='Billing' sx={{ my: 0 }} />
              </ListItemButton>
              :''
              }
              {/* <ListItemButton onClick={() => handleAccount('https://secure.2co.com/myaccount/', true)}>
                <ListItemIcon sx={{ minWidth: 36 }}>
                  <ManageAccountsOutlinedIcon />
                </ListItemIcon>
                <ListItemText primary='Administrators' sx={{ my: 0 }} />
              </ListItemButton>
              <ListItemButton onClick={() => handleAccount('https://secure.2co.com/myaccount/', true)}>
                <ListItemIcon sx={{ minWidth: 36 }}>
                  <DescriptionOutlinedIcon />
                </ListItemIcon>
                <ListItemText primary='Logs' sx={{ my: 0 }} />
              </ListItemButton>
              <Divider />
              <ListItemButton onClick={() => handleAccount('https://secure.2co.com/myaccount/', true)}>
                <ListItemIcon sx={{ minWidth: 36 }}>
                  <ReportProblemOutlinedIcon />
                </ListItemIcon>
                <ListItemText primary='Report' sx={{ my: 0 }} />
              </ListItemButton>
              <ListItemButton onClick={() => handleAccount('https://secure.2co.com/myaccount/', true)}>
                <ListItemIcon sx={{ minWidth: 36 }}>
                  <FeedbackOutlinedIcon />
                </ListItemIcon>
                <ListItemText primary='Feedback' sx={{ my: 0 }} />
              </ListItemButton>
              <Divider /> */}
             
              <ListItemButton onClick={() => {
                  setTimeout(() => {
                    dispatch(openDialog())
                  }, 250)
				  trackEvent("UserProfile", "Menu", "My Profile");
                  handleAccount('/profile', false);
                }}>
                <ListItemIcon sx={{ minWidth: 36 }}>
                  <PersonOutlineIcon />
                </ListItemIcon>
                <ListItemText primary='My profile' sx={{ my: 0 }} />
              </ListItemButton>
              {
                planStore.role === 'admin' ?
               <ListItemButton onClick={() => {
                  trackEvent("UserProfile", "Menu", "My Team");
                  handleAccount('/profile/team', false);
               }}>
                <ListItemIcon sx={{ minWidth: 36 }}>
                  <PeopleAltOutlinedIcon />
                </ListItemIcon>
                <ListItemText primary='My team' sx={{ my: 0 }} />
              </ListItemButton>
              :''
              }          
              {
                <ListItemButton onClick={() => {
                  trackEvent("UserProfile", "Menu", "Developer");
                  handleAccount('/profile/developer', false);
                }}>
                  <ListItemIcon sx={{ minWidth: 36 }}>
                    <CodeOutlinedIcon />
                  </ListItemIcon>
                  <ListItemText primary='Developer' sx={{ my: 0 }} />
                </ListItemButton>
              
              } 
				<ListItemButton onClick={() => {
					trackEvent("UserProfile", "Menu", "Logout");
					logout('redirect');
				}}>
                <ListItemIcon sx={{ minWidth: 36 }}>
                  <LogoutIcon />
                </ListItemIcon>
                <ListItemText primary='Logout' sx={{ my: 0 }} />
              </ListItemButton>
            </List>
          </nav>
        </JumboDdPopover>
      </ThemeProvider>
  );
};

export { AuthUserPopover };
